/* Optional, voluntary, adult pack-results feedback (BEANIFY_OPTIONAL_FEEDBACK_OCT21).
 * Standalone: no dependencies, no cookies, no storage, no timers, no third-party tracking, text-only DOM building.
 * Sends NOTHING until the customer opens the form, chooses a rating and presses "Send feedback".
 * One feedback record per generation (the server overwrites): this is ONE rating for the whole set,
 * never individual ratings for each image. Results stay usable whether or not it is ever opened.
 * Host contract (mount options):
 *   container        element to render into
 *   generationId     the order's generation id (order.generation.bean_generation_id)
 *   results          [{id, label}] built ONLY from this generation's completed slots (bean_character_id)
 *   request(m,p,j)   host fetch helper -> Promise<{ok,status}> (App-Proxy, no bearer, same-origin)
 *   adultConfirmed   true ONLY when the SERVER has just proved eligibility for this generation (GET /generations/{id}/feedback
 *                    -> eligible:true). A signed-in session is never treated as adult proof. The POST re-checks.
 */
(function (global) {
  'use strict';
  var ISSUES = [['nose', 'A nose appears on the Bean'], ['shell_shape', 'The shell looks pinched or elongated'],
    ['likeness', 'It does not look like me'], ['costume', 'The costume looks wrong'], ['delivery', 'Delivery or download problem']];
  var LOOKS = [['yes', 'Yes'], ['somewhat', 'Somewhat'], ['no', 'Not really']];
  var SAT = [[5, 'Very satisfied'], [4, 'Satisfied'], [3, 'Neutral'], [2, 'Dissatisfied'], [1, 'Very dissatisfied']];
  var seq = 0;

  function el(tag, text, parent, attrs) {
    var e = document.createElement(tag);
    if (text !== null && text !== undefined) e.textContent = String(text);
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    if (parent) parent.appendChild(e);
    return e;
  }

  function mount(o) {
    if (!o || !o.container || o.adultConfirmed !== true || typeof o.request !== 'function') return null;
    var gid = typeof o.generationId === 'string' && /^[A-Za-z0-9_-]{1,80}$/.test(o.generationId) ? o.generationId : null;
    var results = (Array.isArray(o.results) ? o.results : []).filter(function (r) {
      return r && typeof r.id === 'string' && r.id && typeof r.label === 'string';
    });
    if (!gid || !results.length) return null;
    var c = o.container;
    if (c.getAttribute('data-feedback-for') === gid) return c.__sccFeedback || null;   // idempotent re-render
    c.replaceChildren(); c.setAttribute('data-feedback-for', gid); c.hidden = false;
    var n = ++seq, ids = new Set(results.map(function (r) { return r.id; }));
    var state = { sending: false, sent: false, closed: false };

    var intro = el('div', null, c);
    var open = el('button', 'Share optional feedback', intro, { type: 'button', 'data-fb-open': '' });
    var decline = el('button', 'No thanks', intro, { type: 'button', 'data-fb-decline': '' });
    el('p', 'Optional. Your Beans are saved and ready whether or not you answer.', intro);
    var form = el('form', null, c, { 'data-fb-form': '', hidden: '' });
    form.noValidate = true;
    el('p', 'This is one rating for the whole set. It is not a rating of each individual image.', form);

    function fieldset(legend, name, rows, type, extra) {
      var f = el('fieldset', null, form); el('legend', legend, f);
      rows.forEach(function (r) {
        var l = el('label', null, f), i = el('input', null, l, { type: type, name: name + n, value: String(r[0]) });
        i.setAttribute(extra, ''); el('span', ' ' + r[1], l);
      });
      return f;
    }
    fieldset('How satisfied are you with this set?', 'fb-sat', SAT, 'radio', 'data-fb-sat');
    fieldset('Does your Bean look like you?', 'fb-looks', LOOKS, 'radio', 'data-fb-looks');
    var fav = el('label', null, form); el('span', 'Favorite image (optional) ', fav);
    var sel = el('select', null, fav, { 'data-fb-fav': '' });
    el('option', 'No favorite', sel, { value: '' });
    results.forEach(function (r) { el('option', r.label, sel, { value: r.id }); });
    fieldset('Any problems? (optional)', 'fb-issue', ISSUES, 'checkbox', 'data-fb-issue');
    var send = el('button', 'Send feedback', form, { type: 'submit', 'data-fb-send': '' });
    var cancel = el('button', 'Cancel', form, { type: 'button', 'data-fb-cancel': '' });
    var status = el('p', null, c, { role: 'status', 'data-fb-status': '', hidden: '' });

    function say(t) { status.textContent = t; status.hidden = !t; }
    open.addEventListener('click', function () { form.hidden = false; intro.hidden = true; });
    function dismiss() { state.closed = true; c.replaceChildren(); c.hidden = true; }
    decline.addEventListener('click', dismiss);
    cancel.addEventListener('click', function () { if (state.sent) { form.hidden = true; intro.hidden = false; } else dismiss(); });
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (state.sending || state.closed) return;
      var satEl = form.querySelector('[data-fb-sat]:checked'), looksEl = form.querySelector('[data-fb-looks]:checked');
      if (!satEl || !looksEl) { say('Please choose a satisfaction rating and whether it looks like you.'); return; }
      var favId = sel.value;
      if (favId && !ids.has(favId)) { say('Please choose a favorite from the list.'); return; }
      var codes = Array.prototype.map.call(form.querySelectorAll('[data-fb-issue]:checked'), function (i) { return i.value; })
        .filter(function (v) { return ISSUES.some(function (x) { return x[0] === v; }); });
      var body = { looks_like_you: looksEl.value, satisfaction: Number(satEl.value) };
      if (favId) body.preferred_character_id = favId;
      if (codes.length) body.issues_encountered = 'codes:' + codes.join(',');
      state.sending = true; send.disabled = true; say('Sending…');
      Promise.resolve().then(function () {
        return o.request('POST', '/generations/' + encodeURIComponent(gid) + '/feedback', body);
      }).then(function (r) {
        state.sending = false; send.disabled = false;
        if (r && r.ok) { state.sent = true; send.textContent = 'Update feedback'; say('Thank you. Your Beans are unchanged.'); }
        else if (r && (r.status === 401 || r.status === 403 || r.status === 404)) {      // server refused: no proof, no form
          state.closed = true; form.hidden = true; intro.hidden = true; say('Feedback is not available for this order. Your Beans are unchanged.');
        } else say('We could not send that just now. Your Beans are still saved. You can try again.');
      }, function () {
        state.sending = false; send.disabled = false;
        say('We could not send that just now. Your Beans are still saved. You can try again.');
      });
    });
    var api = { generationId: gid, state: state };
    c.__sccFeedback = api;
    return api;
  }
  global.SccPackFeedback = { mount: mount, ISSUE_CODES: ISSUES.map(function (x) { return x[0]; }) };
}(typeof window !== 'undefined' ? window : globalThis));
